import React from "react";
import { Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { useIdleTimer } from "react-idle-timer";
import i18n from "./i18n";

// prop types
interface AutoSignOutProps {
    disabled?: boolean,
    onSignOut: () => void,
}

// auto logout timeout
let timeout: NodeJS.Timeout;

// how many seconds till auto sign out
const waitTime = 15;

// automatic sign out (with dialog)
const AutoSignOut = ({ disabled, onSignOut }: AutoSignOutProps) => {
    // snackbar
    const { closeSnackbar, enqueueSnackbar } = useSnackbar();

    // manual options
    const action = (
        <>
            <Button
                onClick={() => {
                    clearTimeout(timeout);
                    closeSnackbar("autoSignOut");
                }}
                style={{ color: "white" }}
            >
                {i18n.staySignedIn}
            </Button>
            <Button
                onClick={() => {
                    clearTimeout(timeout);
                    closeSnackbar("autoSignOut");
                    onSignOut();
                }}
                style={{ color: "white" }}
            >
                {i18n.signOutNow}
            </Button>
        </>
    );

    // idle hook
    const onIdle = () => {
        // reset auto logout timeout
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            closeSnackbar("autoSignOut");
            onSignOut();
        }, 1000 * waitTime);

        // show dialog
        enqueueSnackbar(i18n.autoSignOut(waitTime), {
            action,
            key: "autoSignOut",
            persist: true,
            variant: "info",
        });
    };
    useIdleTimer({
        debounce: 250,
        timeout: 1000 * 60,
        onIdle: disabled ? undefined : onIdle,
    });

    return null;
};

export default AutoSignOut;
